import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { Transaction } from '../../../../../../../store/transactionFlow/types';
import { TransactionFields } from '../../constants';

import { TransactionCard } from './components/TransactionCard';
import { CardLoadingItemMobile } from './components/TransactionCardLoading';

export interface TransactionTableMobileProps {
  data: Transaction[];
  fields: TransactionFields[];
  loading: boolean;
  onSelectClient?: (cpfCnpj: string) => void;
}

export const TransactionTableMobile = ({
  data,
  fields,
  loading,
  onSelectClient,
}: TransactionTableMobileProps) => {
  if (loading) {
    return (
      <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
        {Array.from({ length: 5 }).map((_, index) => (
          <CardLoadingItemMobile key={index.toString()} />
        ))}
      </VStack>
    );
  }

  return (
    <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
      {data.map((item, index) => (
        <TransactionCard
          key={index.toString()}
          item={item}
          infos={fields}
          onSelectClient={onSelectClient}
        />
      ))}
    </VStack>
  );
};
